module.exports = __webpack_public_path__ + "static/img/yx-bj.3bac432.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yx-bj.png
// module id = DAza
// module chunks = 1